// extracted by mini-css-extract-plugin
module.exports = {"scroller":"MovieRecommendations_scroller__RRsww"};